import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../Provider/AuthProvider";

const Navdata = () => {
    const history = useNavigate();

    const [isDashboard, setIsDashboard] = useState(false);
    const [iscurrentState, setIscurrentState] = useState('Dashboard');

    // get user + allowed interfaces
    const { allowedInterfaces, user } = useAuth();

    function updateIconSidebar(e: any) {
        if (e?.target?.getAttribute("sub-items")) {
            const ul: any = document.getElementById("two-column-menu");
            const iconItems: any = ul?.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove("active");
                const id = item.getAttribute("sub-items");
                const getID = document.getElementById(id) as HTMLElement;
                getID?.classList.remove("show");
            });
        }
    }

    useEffect(() => {
        document.body.classList.remove('twocolumn-panel');

        const states = {
            Dashboard: setIsDashboard,
        };

        Object.entries(states).forEach(([key, setter]) => {
            if (iscurrentState !== key) setter(false);
        });

        if (iscurrentState === 'Widgets') {
            history("/widgets");
            document.body.classList.add('twocolumn-panel');
        }

    }, [history, iscurrentState]);

    const menuItems = useMemo(() => {
        const baseItems = [
            {
                label: "Menu",
                isHeader: true,
            },
            {
                id: "caisse",
                label: "Caisse",
                icon: "mdi mdi-monitor-dashboard",
                link: "/caisse",
                stateVariables: isDashboard,
                status:
                    allowedInterfaces.includes("caisse") &&
                    user?.perms?.facture?.paiement != null,   // <-- permission check 
                click: function (e: any) {
                    e.preventDefault();
                    setIsDashboard(!isDashboard);
                    setIscurrentState("Caisse");
                    updateIconSidebar(e);
                },
            },
            {
                id: "vendeur",
                label: "Vendeur",
                icon: "mdi mdi-cart",
                link: "/vendeur",
                stateVariables: isDashboard,
                status: allowedInterfaces.includes("vendeur") && user?.perms?.commande?.creer != null && user?.perms?.propal?.creer != null,
                click: function (e: any) {
                    e.preventDefault();
                    setIsDashboard(!isDashboard);
                    setIscurrentState("Vendeur");
                    updateIconSidebar(e);
                },
            },
            {
                id: "commandes",
                label: "Commandes",
                icon: "mdi mdi-shopping-outline",
                link: "/commandes",
                stateVariables: isDashboard,
                status: allowedInterfaces.includes("commandes") && user?.perms?.commande?.creer != null && (user?.perms?.propal?.creer != null || user?.perms?.propale?.creer != null),
                click: function (e: any) {
                    e.preventDefault();
                    setIsDashboard(!isDashboard);
                    setIscurrentState("commandes");
                    updateIconSidebar(e);
                },
            },
            {
                id: "factures",
                label: "Factures",
                icon: "mdi mdi-clipboard-text",
                link: "/factures",
                stateVariables: isDashboard,
                status: allowedInterfaces.includes("commandes") && user?.perms?.commande?.creer != null && (user?.perms?.propal?.creer != null || user?.perms?.propale?.creer != null),
                click: function (e: any) {
                    e.preventDefault();
                    setIsDashboard(!isDashboard);
                    setIscurrentState("commandes");
                    updateIconSidebar(e);
                },
            },
            {
                id: "Préparation",
                label: "Préparation",
                icon: "mdi mdi-tools",
                link: "/preparation",
                stateVariables: isDashboard,
                status: allowedInterfaces.includes("stock")
                    && user?.perms?.commande?.creer == null
                    && user?.perms?.stock?.mouvement?.creer != null,
                click: function (e: any) {
                    e.preventDefault();
                    setIsDashboard(!isDashboard);
                    setIscurrentState("Préparation");
                    updateIconSidebar(e);
                },
            },
            {
                id: "Commande",
                label: "Commandes en attentes",
                icon: "mdi mdi-clock-outline",
                link: "/CommandesEnAttentes",
                stateVariables: isDashboard,
                status: allowedInterfaces.includes("stock")
                    && user?.perms?.commande?.creer == null
                    && user?.perms?.stock?.mouvement?.creer != null,
                click: function (e: any) {
                    e.preventDefault();
                    setIsDashboard(!isDashboard);
                    setIscurrentState("Commande");
                    updateIconSidebar(e);
                },
            },

            {
                id: "devis",
                label: "Devis",
                icon: "mdi mdi-file-document-outline",
                link: "/devis",
                stateVariables: isDashboard,
                status: allowedInterfaces.includes("commandes") && (user?.perms?.propal?.creer != null || user?.perms?.propale?.creer != null),
                click: function (e: any) {
                    e.preventDefault();
                    setIsDashboard(!isDashboard);
                    setIscurrentState("devis");
                    updateIconSidebar(e);
                },
            },
            //{
            //    id: "piecesenattentes",
            //    label: "Pièce en attente",
            //    icon: "mdi mdi-file-clock-outline",
            //    link: "/piecesenattentes",
            //    stateVariables: isDashboard,
            //    status: allowedInterfaces.includes("devis") && user?.perms?.propal?.creer != null,
            //    click: function (e: any) {
            //        e.preventDefault();
            //        setIsDashboard(!isDashboard);
            //        setIscurrentState("devis");
            //        updateIconSidebar(e);
            //    },
            //},

            {
                id: "Stock",
                label: "Stock / Réceptions",
                icon: "mdi mdi-newspaper-variant-outline",
                link: "/stock",
                stateVariables: isDashboard,
                status: (() => {
                    const stockOnReception = Number(user?.conf?.STOCK_CALCULATE_ON_RECEPTION) === 1;
                    const stockOnValidateOrder = Number(user?.conf?.STOCK_CALCULATE_ON_VALIDATE_ORDER) === 1;
                    const hasStockMvt = user?.perms?.stock?.mouvement?.creer != null;
                    const hasCommandeCreer = user?.perms?.commande?.creer != null;

                    // Cas A : stock calculé à la réception (pas à la validation) -> profil stockiste pur
                    const caseA = stockOnReception && !stockOnValidateOrder
                        && !hasCommandeCreer
                        && hasStockMvt;

                    // Cas B : stock calculé à la validation de commande -> le vendeur gère aussi le stock
                    // Il suffit que stockOnValidateOrder soit actif (peu importe stockOnReception)
                    const caseB = stockOnValidateOrder
                        && hasCommandeCreer
                        && hasStockMvt;

                    return allowedInterfaces.includes("stock") && (caseA || caseB);
                })(),
                click: function (e: any) {
                    e.preventDefault();
                    setIsDashboard(!isDashboard);
                    setIscurrentState("Stock");
                    updateIconSidebar(e);
                },
            },

            {
                id: "piecesenattentes",
                label: "Pièces en attentes",
                icon: "mdi mdi-file-clock-outline",
                link: "/piecesenattentes",
                stateVariables: isDashboard,
                status: allowedInterfaces.includes("stock")
                    || user?.perms?.propal?.lire != null,
                click: function (e: any) {
                    e.preventDefault();
                    setIsDashboard(!isDashboard);
                    setIscurrentState("Stock");
                    updateIconSidebar(e);
                }, iconStyle: { color: "#ffc107" }
            },

              {
                id: "commandesenstock",
                label: "Commandes stock",
                icon: "mdi mdi-package-down",
                link: "/CommandesStock",
                stateVariables: isDashboard,
                status: allowedInterfaces.includes("stock")
                    || user?.perms?.propal?.lire != null,
                click: function (e: any) {
                    e.preventDefault();
                    setIsDashboard(!isDashboard);
                    setIscurrentState("Stock");
                    updateIconSidebar(e);
                }, iconStyle: { color: "#ffc107" }
            },

            {
                id: "pickups",
                label: "Pickups",
                icon: "mdi mdi-truck-fast-outline",
                link: "/pickups",
                stateVariables: isDashboard,
                status: user?.perms?.fournisseur?.commande?.receptionner != null && user?.perms?.expedition?.delivery == null,
                click: function (e: any) {
                    e.preventDefault();
                    setIsDashboard(!isDashboard);
                    setIscurrentState("Pickups");
                    updateIconSidebar(e);
                },
            },

            {
                id: "expeditions",
                label: "Expéditions",
                icon: "mdi mdi-package-variant",
                link: "/expeditions",
                stateVariables: isDashboard,
                status: allowedInterfaces.includes("stock")
                    && user?.perms?.commande?.creer == null
                    && user?.perms?.stock?.mouvement?.creer != null,
                click: function (e: any) {
                    e.preventDefault();
                    setIsDashboard(!isDashboard);
                    setIscurrentState("Préparation");
                    updateIconSidebar(e);
                }, iconStyle: { color: "#ffc107" }
            },

            {
                id: "dashboard",
                label: "Dashboard",
                icon: "mdi mdi-view-dashboard",
                link: "/index",
                stateVariables: isDashboard,
                status: true && !(user?.perms?.fournisseur?.commande?.receptionner != null && user?.perms?.expedition?.delivery == null),
                click: function (e: any) {
                    e.preventDefault();
                    setIsDashboard(!isDashboard);
                    setIscurrentState("Dashboard");
                    updateIconSidebar(e);
                },
            },



        ];

        return baseItems.filter(item => !item.isHeader || (item.status !== false));
    }, [allowedInterfaces, isDashboard, user]);

    return menuItems;
};

export default Navdata;
